import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import SignerCeremony from './SignerCeremony';
import reportWebVitals from './reportWebVitals';

// Path-based routing happens here, before any component mounts, so
// signing flow and documents portal never coexist in the React tree.
// Avoids pulling in react-router for the single signing route.
function pickRoute(): React.ReactNode {
  const m = window.location.pathname.match(/^\/sign\/([^/?#]+)/);
  if (m) return <SignerCeremony token={decodeURIComponent(m[1])} />;
  return <App />;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {pickRoute()}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
